<template>
  <div id="app" class="relative bb-ofx-hidden bb-min-h100p flex flex-column"
  :class="[this.$router.history.current.meta.bgBlack ? 'bb-bc-black' :
  'bb-bc12', (showModal || showLogoutModal) ? 'fixed top-0 right-0 left-0' : '']">
    <top id="header"></top>
    <router-view class="content border-box bb-w100p bb-fullscreen bb-fl1"
       :key="$route.fullPath" style="margin-bottom: 8rem"></router-view>
    <bot id="footer" class="flex-none"></bot>
    <transition name="fade">
      <login-modal
        v-if="showModal"
        :loginData="selectedOptions"
        v-on:cancelLoginEmit="cancelLogin"
        v-on:emitNotification="displayNoti">
      </login-modal>
    </transition>
    <transition name="fade">
      <logout-modal
        v-if="showLogoutModal"
        v-on:cancelLogoutEmit="cancelLogout">
      </logout-modal>
    </transition>
    <mini-notification v-if="displayNotification" :msg="displayNotification.msg"
    :success="displayNotification.state" class="bb-fullscreen"
    :class="[ displayNotification.show ? 'top-0 bb-visible' : 'bb-topn2pt5 bb-hidden' ]">
    </mini-notification>
  </div>
</template>

<script>
import header from '@/components/header'
import footer from '@/components/footer'
import loginModal from '@/components/loginModal'
import logoutModal from '@/components/logoutModal'
import miniNotification from '@/components/miniNotification'
export default {
  name: 'app',
  components: {
    'top': header,
    'bot': footer,
    'login-modal': loginModal,
    'logout-modal': logoutModal,
    'mini-notification': miniNotification
  },
  data () {
    return {
      timer: null
    }
  },
  methods: {
    cancelLogin: function () {
      this.$store.commit('SET_SHOW_MODAL', false)
    },
    displayNoti: function (msgs) {
      this.$store.commit('SET_DISPLAY_NOTIFICATION', {show: true, msg: msgs, state: false})
    },
    cancelLogout: function () {
      this.$store.commit('SET_SHOW_LOGOUT_MODAL', false)
    }
  },
  computed: {
    showModal () {
      return this.$store.getters.getShowModal
    },
    selectedOptions () {
      return this.$store.getters.getSelectedOptions
    },
    showLogoutModal () {
      return this.$store.getters.getShowLogoutModal
    },
    displayNotification () {
      return this.$store.getters.getDisplayNotification
    }
  },
  watch: {
    displayNotification: function () {
      var self = this
      window.clearTimeout(this.timer)
      self.timer = window.setTimeout(function () {
        self.$store.commit('SET_DISPLAY_NOTIFICATION', {show: false})
      }, 3000)
    }
  },
  created () {
    if (this.$localStorage.get('token') && this.$localStorage.get('profileId')) {
      this.$store.commit('SET_LOGGEDIN', true)
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'Montserrat-Light';
  src: url('./fonts/Montserrat-Light_1.woff') format('woff');
}

@font-face {
  font-family: 'Montserrat-Regular';
  src: url('./fonts/Montserrat-Regular[1].woff') format('woff');
}

@font-face {
  font-family: 'Montserrat-SemiBold';
  src: url('./fonts/Montserrat-SemiBold.woff') format('woff');
}

#app > *, .content > * {
  max-width: 120rem; margin-left: auto !important; margin-right: auto !important;
}

#app .bb-fullscreen {
  max-width: initial; margin-left: initial; margin-right: initial;
}

.bb-ff1 {
  font-family: 'Montserrat-SemiBold';
}

.bb-ff2 {
  font-family: 'Montserrat-Light';
}

.bb-ff3 {
  font-family: 'Montserrat-Regular';
}

.bb-fc1 {
  color: #ffffff;
}

.bb-fc1-hover:hover {
  color: #ffffff !important;
}

.bb-fc2 {
  color: #ff3364;
}

.bb-fc2-hover:hover {
  color: #ff3364;
}

.bb-fc3 {
  color: #cccccc;
}

.bb-fc4 {
  color: #1fc5ed;
}

.bb-fc5 {
  color: #f26621;
}

.bb-fc6 {
  color: #1dad4d;
}

.bb-fc7 {
  color: rgba(255, 51, 99, 0.8);
}

.bb-fc8-hover:hover {
  color: rgba(255, 51, 99, 1);
}

.bb-fc9-hover:hover *{
  color: #ffffff;
}

.bb-fc10 {
  color: #7C7C7C;
}

.bb-fc11 {
  color: #ffffff !important;
}

.bb-fc12 {
  color: #d9c193;
}

.bb-fc13 {
  color: transparent;
}

.bb-fc14 {
  color: #838383;
}

.bb-fc15 {
  color: #999999;
}

.bb-fc16 {
  color: #000000;
}

.bb-fs0 {
  font-size: 0;
}

.bb-fs1 {
  font-size: 1rem;
}

.bb-fs1pt13 {
  font-size: 1.13rem;
}

.bb-fs1pt17 {
  font-size: 1.17rem;
}

.bb-fs1pt2 {
  font-size: 1.2rem;
}

.bb-fs1pt29 {
  font-size: 1.29rem;
}

.bb-fs1pt5 {
  font-size: 1.5rem;
}

.bb-fs1pt79 {
  font-size: 1.79rem;
}

.bb-fs1pt91 {
  font-size: 1.91rem;
}

.bb-fs2pt17 {
  font-size: 2.17rem;
}

.bb-bc1 {
  background-color: #262626;
}

.bb-bc2 {
  background-color: #ff3364;
}

.bb-bc2-hover:hover {
  background-color: #ff3364;
}

.bb-bc3 {
  background-color: rgba(0, 0, 0, 0.7);
}

.bb-bc4 {
  background-color: rgba(0, 180, 0, 1);
}

.bb-bc5 {
  background-color: rgba(220, 0, 0, 1);
}

.bb-bc6 {
  background-color: #1fc5ed;
}

.bb-bc7 {
  background-color: #f26621;
}

.bb-bc8 {
  background-color: #cccccc;
}

.bb-bc9 {
  background-color: #1dad4d;
}

.bb-bc9:hover {
  background-color: #1dad4d;
}

.bb-bc10 {
  background: linear-gradient(-45deg, rgba(82, 1, 63, 0.5) 1%, rgba(89, 38, 199, 0.5) 100%);
}

.bb-bc11 {
  background: #FFFFFF;
}

.bb-bc12-hover:hover {
  background-color: #f26621;
}

.bb-bc12 {
  background: linear-gradient(-45deg, rgba(18, 0, 37, 1) 1%, rgba(24, 0, 18, 1) 100%);
}

.bb-bc13 {
  background-color: #2F2737;
}

.bb-bc-black {
  background-color: black;
}

.bb-bc-transp {
  background-color: transparent;
}

.bb-w45px {
  width: 45px;
}

.bb-w0pt5 {
  width: 0.5rem;
}

.bb-w0pt7 {
  width: 0.7rem;
}

.bb-w0pt75 {
  width: 0.75rem;
}

.bb-w0pt9 {
  width: 0.9rem;
}

.bb-w1pt25 {
  width: 1.25rem;
}

.bb-w1pt5 {
  width: 1.5rem;
}

.bb-w2pt5 {
  width: 2.5rem;
}

.bb-w3 {
  width: 3rem;
}

.bb-w3pt5 {
  width: 3.5rem;
}

.bb-w4 {
  width: 4rem;
}

.bb-w5 {
  width: 5rem;
}

.bb-w7 {
  width: 7rem;
}

.bb-w8 {
  width: 8rem;
}

.bb-w9 {
  width: 9rem;
}

.bb-w12 {
  width: 12rem;
}

.bb-w15 {
  width: 15rem;
}

.bb-w20 {
  width: 20rem;
}

.bb-w24pt12 {
  width: 24.12rem;
}

.bb-w28 {
  width: 28rem;
}

.bb-w29 {
  width: 29rem;
}

.bb-w33 {
  width: 33rem;
}

.bb-w38 {
  width: 38rem;
}

.bb-w175 {
  width: 175rem;
}

.bb-w100vw {
  width: 100vw;
}

.bb-w80p {
  width: 80%;
}

.bb-w100p {
  width: 100%;
}

.bb-w110p {
  width: 110%;
}

.bb-w130p {
  width: 130%;
}

.bb-mxw30 {
  max-width: 30rem;
}

.bb-mxw31pt3 {
  max-width: 31.3rem;
}

.bb-max-w34 {
  max-width: 34rem;
}

.bb-max-w40 {
  max-width: 40rem;
}

.bb-max-w50 {
  max-width: 50rem;
}

.bb-max-w100 {
  max-width: 100rem;
}

.bb-h45px {
  height: 45px;
}

.bb-h0pt1 {
  height: 0.1rem;
}

.bb-h0pt125 {
  height: 0.125rem;
}

.bb-h0pt2 {
  height: 0.2rem;
}

.bb-h0pt5 {
  height: 0.5rem;
}

.bb-h0pt75 {
  height: 0.75rem;
}

.bb-h1pt5 {
  height: 1.5rem;
}

.bb-h2 {
  height: 2rem;
}

.bb-h2pt5 {
  height: 2.5rem;
}

.bb-h2pt8 {
  height: 2.8rem;
}

.bb-h3 {
  height: 3rem;
}

.bb-h4pt5 {
  height: 4.5rem;
}

.bb-h5 {
  height: 5rem;
}

.bb-h5pt31 {
  height: 5.31rem;
}

.bb-h7pt1 {
  height: 7.1rem;
}

.bb-h10pt5 {
  height: 10.5rem;
}

.bb-h12 {
  height: 12rem;
}

.bb-h12pt25 {
  height: 12.25rem;
}

.bb-h13pt5 {
  height: 13.5rem;
}

.bb-h13pt75 {
  height: 13.75rem;
}

.bb-h16 {
  height: 16rem;
}

.bb-h16pt5 {
  height: 16.5rem;
}

.bb-h18pt77 {
  height: 18.77rem;
}

.bb-h25 {
  height: 25rem;
}

.bb-h28 {
  height: 28rem;
}

.bb-h30 {
  height: 30rem;
}

.bb-h40 {
  height: 40rem;
}

.bb-h100p {
  height: 100%;
}

.bb-h90p {
  height: 90%;
}

.bb-h130p {
  height: 130%;
}

.bb-h60vh {
  height: 60vh;
}

.bb-h100vh {
  height: 100vh;
}

.bb-min-h2pt5 {
  min-height: 2.5rem;
}

.bb-min-h8 {
  min-height: 8rem;
}

.bb-min-h10 {
  min-height: 10rem;
}

.bb-min-h20 {
  min-height: 20rem;
}

.bb-min-h100p {
  min-height: 100%;
}

.bb-hcr {
  left: 50%; transform: translateX(-50%);
}

.bb-vcr {
  top: 50%; transform: translateY(-50%);
}

.bb-vhcr {
  left: 50%; top: 50%; transform: translate(-50%, -50%);
}

.bb-rotateY40 {
  transform: rotateY(40deg);
}

.bb-rotateY70 {
  transform: rotateY(70deg);
}

.bb-rotateYn40 {
  transform: rotateY(-40deg);
}

.bb-rotateYn70 {
  transform: rotateY(-70deg);
}

.bb-transform1 {
  transition: transform 0.2s ease;
}

.bb-transform2 {
  transform: translateY(-30px);
}

.bb-transform3 {
  transform: translateY(-25px);
}

.bb-perspective100 {
  perspective: 100vw;
}

.bb-hidden {
  visibility: hidden;
}

.bb-visible {
  visibility: visible;
}

.bb-pointer {
  cursor: pointer;
}

.bb-default {
  cursor: default;
}

.bb-bg-no-repeat {
  background-repeat: no-repeat;
}

.bb-bgp-center {
  background-position: 50%;
}

.bb-bgs-cover {
  background-size: cover;
}

.bb-of-hidden {
  overflow: hidden;
}

.bb-ofx-hidden {
  overflow: hidden;
}

.bb-ofy-scroll {
  overflow-y: scroll;
}

.bb-ofy-auto {
  overflow-y: auto;
}

.bb-transition1 {
  transition: all 0.5s;
}

.bb-transition2 {
  transition: all 0.25s;
}

.bb-transition3 {
  transition: all 0.2s;
}

.bb-transition4 {
  transition: all 0.2s;
}

.bb-hover-trigger1:hover .bb-transition3,
.bb-hover-trigger1:hover.bb-transition3 {
  opacity: 1;
}

.bb-hover-trigger1:hover .bb-transition4,
.bb-hover-trigger1:hover.bb-transition4 {
  color: #F26621;
}

.bb-hover-trigger2:hover .bb-bc12-hover {
  background-color: #f26621;
}

.bb-mt0pt1 {
  margin-top: 0.1rem;
}

.bb-mt0pt81 {
  margin-top: 0.81rem;
}

.bb-mt1pt2 {
  margin-top: 1.2rem;
}

.bb-mt1pt3 {
  margin-top: 1.3rem;
}

.bb-mt1pt5 {
  margin-top: 1.5rem;
}

.bb-mt1pt7 {
  margin-top: 1.7rem;
}

.bb-mt2pt56 {
  margin-top: 2.56rem;
}

.bb-mt2pt6 {
  margin-top: 2.6rem;
}

.bb-mt3pt56 {
  margin-top: 3.56rem;
}

.bb-mt5pt37 {
  margin-top: 5.375rem;
}

.bb-mb0pt7pt5 {
  margin-bottom: 0.75rem;
}

.bb-mb0pt81 {
  margin-bottom: 0.81rem;
}

.bb-mb2pt56 {
  margin-bottom: 2.56rem;
}

.bb-ml5 {
  margin-left: 5rem;
}

.bb-ml0 {
  margin-left: 0 !important;
}

.bb-mln0pt6 {
  margin-left: -0.6rem;
}

.bb-mx1 {
  margin-left: 10rem;
  margin-right: 10rem;
}

.bb-mx2 {
  margin-left: 2rem;
  margin-right: 2rem;
}

.bb-pb2pt56 {
  padding-bottom: 2.56rem;
}

.bb-pb12 {
  padding-bottom: 12rem;
}

.bb-py1pt25 {
  padding-bottom: 1.25rem; padding-top: 1.25rem;
}

.bb-pt0pt81 {
  padding-top: 0.81rem;
}

.bb-pl20p {
  padding-left: 20%;
}

.bb-pr20p {
  padding-right: 20%;
}

.bb-px0pt8 {
  padding-right: 0.8rem;
  padding-left: 0.8rem;
}

.bb-px2pt6 {
  padding-right: 2.6rem;
  padding-left: 2.6rem;
}

.bb-topn2pt5 {
  top: -2.5rem;
}

.bb-topn1pt5 {
  top: -1.5rem;
}

.bb-top1 {
  top: 0.8rem;
}

.bb-top3 {
  top: 3rem;
}

.bb-top3pt3 {
  top: 3.3rem;
}

.bb-rightn1pt5 {
  right: -1.5rem;
}

.bb-right2 {
  right: 2rem;
}

.bb-vhcr {
  left: 50%;top: 50%;transform: translate(-50%, -50%); /*vertical and horizontal center*/
}

.bb-leftn1 {
  left: -1rem;
}

.bb-left2 {
  left: 2rem;
}

.bb-op0 {
  opacity: 0;
}

.bb-op0pt3 {
  opacity: 0.3;
}

.bb-op0pt5 {
  opacity: 0.5;
}

.bb-op0pt6 {
  opacity: 0.6;
}

.bb-op0pt75 {
  opacity: 0.75;
}

.bb-op1 {
  opacity: 1;
}

.bb-op1-hover:hover {
  opacity: 1;
}

.bb-br0pt5 {
  border-radius: 0.5rem;
}

.bb-br2 {
  border-radius: 2rem;
}

.bb-br5 {
  border-radius: 5px;
}

.bb-br10 {
  border-radius: 10px;
}

.bb-brd1 {
  border: 1px solid #f26621;
}

.bb-brd2 {
  border: 1px solid #cccccc;
}

.bb-brd3 {
  border: 1px solid #ff3364;
}

.bb-brd3-hover:hover {
  border: 1px solid #ff3364;
}

.bb-brd4 {
  border: 1px solid #1dad4d;
}

.bb-brd5 {
  border: 1px solid #f26621;
}

.bb-brd6 {
  border: 1px solid #999999;
}

.bb-brd-left0 {
  border-left: 0;
}

.bb-brd-right0 {
  border-right: 0;
}

.bb-brd-top0 {
  border-top: 0;
}

.bb-brd-bot1 {
  border-bottom: 1px solid #2F2737;
}

.bb-brd-bot2 {
  border-bottom: 1px solid #999999;
}

.bb-zindexn1 {
  z-index: -1;
}

.bb-zindex0 {
  z-index: 0;
}

.bb-zindex1 {
  z-index: 1;
}

.bb-zindex2 {
  z-index: 11;
}

.bb-rtl {
  direction: rtl;
}

.bb-scaleX-0 {
  transform: scaleX(0);
}

.bb-scaleX-1 {
  transform: scaleX(1);
}

.bb-scale-1pt1 {
  transform: scale(1.1);
}

.bb-scale-1pt2 {
  transform: scale(1.2);
}

.bb-gradient1 {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.8) 100%);
}

.bb-shadow1 {
  box-shadow: 7px 7px 18px rgba(0, 0, 0, 0.45);
}

.bb-lh0 {
  line-height: 0;
}

.bb-lh1pt5 {
  line-height: 1.5rem;
}

.bb-lh2 {
  line-height: 2rem;
}

.bb-lh2pt3 {
  line-height: 2.3rem;
}

.bb-lh2pt5 {
  line-height: 2.5rem;
}

.bb-lh2pt8 {
  line-height: 2.8rem;
}

.bb-jcc {
  justify-content: center;
}

.bb-aic {
  align-items: center;
}

.bb-usnone {
  user-select: none;
}

.bb-hyphens-auto {
  hyphens: auto;
}

.bb-events-none {
  pointer-events: none;
}

::-webkit-input-placeholder {
  color: #cccccc;
}

::-moz-placeholder {
   color: #cccccc;
}

:-ms-input-placeholder {
   color: #cccccc;
}

::-ms-input-placeholder {
   color: #cccccc;
}

.bb-table-layout-fixed {
  table-layout: fixed;
}

.bb-fl1 {
  flex: 1 0 auto;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .25s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

/* 368px breakpoint, only used for scaling*/
@media screen and (min-width: 23em) {
  html {
    font-size: 12px !important;
  }

  .bb-sm-w70 {
    width: 70rem !important;
  }

  .bb-sm-w30 {
    width: 30rem !important;
  }

  .bb-sm-fc2 {
    color: #ff3364 !important;
  }

  .bb-sm-fc3 {
    color: #1dad4d !important;
  }

  .bb-sm-bc-transp {
    background-color: transparent;
  }
}
  
/*640px breakpoint in width, , 700px breakpoint in height*/
@media screen and (min-width: 40em) and (min-height: 43.75em) {
  html {
    font-size: 14px !important;
  }

  .bb-sm-w5 {
    width: 5rem !important;
  }
  
  .bb-sm-mt0pt81 {
    margin-top: 0.81rem !important;
  }

  .bb-sm-fs1pt5 {
    font-size: 1.5rem !important;
  }

  .bb-sm-mx10 {
    margin-left: 10rem !important;
    margin-right: 10rem !important;
  }

}

/*736px breakpoint*/
@media screen and (min-width: 46em) {
  .bb-mid-w30 {
    width: 30rem !important;
  }

  .bb-mid-w33 {
    width: 33rem !important;
  }

  .bb-mid-w35 {
    width: 35rem !important;
  }

  .bb-mid-w42 {
    width: 42rem !important;
  }

  .bb-mid-max-w15 {
    max-width: 15rem !important;
  }

  .bb-mid-max-w30pt81 {
    max-width: 30.81rem !important;
  }

  .bb-mid-mt0pt81 {
    margin-top: 0.81rem !important;
  }

  .bb-mid-pl0pt4 {
    padding-left: 0.4rem !important;
  }

  .bb-mid-pr0pt4 {
    padding-right: 0.4rem !important;
  }
}

/*832px breakpoint*/
@media screen and (min-width: 52em) {
  .bb-md-left {
    float: left !important;
  }

  .bb-md-right {
    float: right !important;
  }

  .bb-md-pl0pt405 {
    padding-left: 0.405rem !important;
  }

  .bb-md-pl1pt5 {
    padding-left: 1.5rem;
  }

  .bb-md-pr0pt405 {
    padding-right: 0.405rem !important;
  }

  .bb-md-pr0pt5 {
    padding-right: 0.5rem !important;
  }

  .bb-md-pl0pt5 {
    padding-left: 0.5rem !important;
  }

  .bb-md-pl1pt5 {
    padding-left: 1.5rem !important;
  }

  .bb-md-mx1 {
    margin-right: 15rem !important;
    margin-left: 15rem !important;
  }

  .bb-md-w40 {
    width: 40rem !important;
  }

}

/*1024px breakpoint*/
@media screen and (min-width: 64em) {
  .bb-lg-inline-block {
    display: inline-block;
  }

  .bb-lg-ml1 {
    margin-left: 1rem !important;
  }

  .bb-lg-mt0 {
    margin-top: 0 !important;
  }

  .bb-lg-mb0 {
    margin-bottom: 0 !important;
  }

  .bb-lg-ml2 {
    margin-left: 2rem !important;
  }

  .bb-lg-ml3 {
    margin-left: 3rem !important;
  }

  .bb-lg-mln2pt5 {
    margin-left: -2.5rem;
  }

  .bb-lg-mr4 {
    margin-right: 4rem !important;
  }

  .bb-lg-left-0 {
    left: 0 !important;
  }

  .bb-lg-left-align {
    text-align: left !important;
  }

  .bb-lg-ltr {
    direction: ltr !important;
  }

  .bb-lg-right-0 {
    right: 0 !important;
  }

  .bb-lg-right-align {
    text-align: right !important;
  }

  .bb-lg-rtl {
    direction: rtl !important;
  }

  .bb-lg-reset-hcr {
    left: auto !important;
    transform: initial !important;
  }

  .bb-lg-pt0 {
    padding-top: 0 !important;
  }

  .bb-lg-op0 {
    opacity: 0 !important;
  }

  .bb-lg-w50 {
    width: 50rem !important;
  }

  .bb-lg-top-n6pt2 {
    top: -6.2rem !important;
  }

  .bb-lg-h25 {
    height: 25rem;
  }
}

/*1280px breakpoint*/
@media screen and (min-width: 73em) {
  .bb-xl-show {
    display: block !important;
  }

  .bb-xl-hide {
    display: none !important;
  }

  .bb-xl-jcl {
    justify-content: left !important;
  }

  .bb-xl-right {
    float: right !important;
  }

  .bb-xl-mxw100p {
    max-width: 100% !important;
  }

  .bb-xl-mxw30 {
    max-width: 30rem !important;
  }

  .bb-xl-max-w55 {
    max-width: 55rem !important;
  }

  .bb-xl-mli {
    margin-left: initial !important;
  }

  .bb-xl-mln2pt5 {
    margin-left: -2.5rem !important;
  }

  .bb-xl-ml0 {
    margin-left: 0rem !important;
  }

  .bb-xl-ml1 {
    margin-left: 1rem !important;
  }

  .bb-xl-ml2 {
    margin-left: 2rem !important;
  }

  .bb-xl-mr1 {
    margin-right: 1rem !important;
  }

  .bb-xl-mt0 {
    margin-top: 0 !important;
  }

  .bb-xl-mt0pt81 {
    margin-top: 0.81rem !important;
  }

  .bb-xl-mt1 {
    margin-top: 2.56rem !important;
  }

  .bb-xl-mt2 {
    margin-top: 1rem !important;
  }

  .bb-xl-mt3 {
    margin-top: 2rem !important;
  }

  .bb-xl-pl0 {
    padding-left: 0 !important;
  }

  .bb-xl-pl1 {
    padding-left: 1rem !important;
  }

  .bb-xl-pl2 {
    padding-left: 2rem !important;
  }

  .bb-xl-pr2 {
    padding-right: 2rem !important;
  }

  .bb-xl-px2 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .bb-xl-pr40p {
    padding-right: 40% !important;
  }

  .bb-xl-left-align {
    text-align: left !important;
  }

  .bb-xl-right-align {
    text-align: right !important;
  }

  .bb-xl-brd-left0 {
    border-left: 0 !important;
  }

  .bb-xl-justify {
    text-align: justify !important;
  }

  .bb-xl-w70 {
    width: 70rem !important;
  }
  
  .bb-xl-hover-trigger2:hover img {
    transform: scale3d(1.05, 1.05, 1);
  }

  .bb-xl-pointer {
    cursor: pointer !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue